module.exports = __webpack_public_path__ + "static/media/img_sendero.bb33a2f5.jpg";